<div width="w-100">
  <ngb-carousel #carousel
    [interval]="5000">
    @for (img of heroImages; track img) {
      <ng-template ngbSlide>
        <img [src]="img" alt="Luna Contact Lens Fulfillment" class="d-block w-100" />
      </ng-template>
    }
  </ngb-carousel>
</div>
